export class Utility {
  static StripePK = process.env.REACT_APP_STRIPE_PK;
  static getStripe() {
    const stripe = window.Stripe?.(Utility.StripePK!);
    return stripe;
  }

  static arrayBufferToBase64( buffer:string ) {
    var binary = '';
    var bytes = new Uint8Array( buffer as any);
    var len = bytes.byteLength;
    for (var i = 0; i < len; i++) {
       binary += String.fromCharCode( bytes[ i ] );
    }
    return window.btoa( binary );
  }

  static blobToBase64(blob:Blob) {
    // var reader = new FileReader();
    // reader.onloadend = function() {
    //   var base64data = reader.result;                
    //   console.log(base64data);
    // }
    // reader.readAsDataURL(blob); 
    
    return new Promise<string>((resolve, _) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result as string);
      reader.readAsDataURL(blob);
    });
  }
}
